// extracted by mini-css-extract-plugin
module.exports = {"breathe":"ripple_breathe__PGkK6","breathe-ani":"ripple_breathe-ani__rtZh2"};